"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
export default function Hero() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1,
    once: true
  });
  return <section id="hero" className="relative w-full min-h-[35vh] flex flex-col lg:flex-row bg-background overflow-hidden">
      {/* Bloc texte – gauche */}
      <div className="w-full flex flex-col justify-center px-6 py-10 z-10 !bg-[#D4CBBA] lg:w-1/2 lg:p-10 xl:p-14">
        <div ref={ref} className={`max-w-2xl mx-auto lg:mx-0 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          <h1 className="font-serif text-3xl md:text-4xl lg:text-5xl leading-tight font-bold mb-4 text-[hsl(343,80%,35%)] tracking-tight">
            Cadre juridique de la formation professionnelle&nbsp;: sécurisez
            votre conformité
          </h1>

          <p className="font-sans text-base md:text-lg mb-6 text-[hsl(210,10%,23%)] max-w-xl leading-relaxed">
            Effet Conseil accompagne les organismes prestataires d'actions
            concourant au développement des compétences (formation, bilan de
            compétences, VAE, apprentissage) et les organismes certificateurs
            pour mettre leur activité en conformité avec le Code du travail, à
            jour de la loi n°&nbsp;2026-534 du 25&nbsp;juin 2026 relative à la
            lutte contre les fraudes sociales et fiscales.
          </p>

          <Button asChild size="lg" className="!bg-[hsl(343,80%,35%)] text-white hover:!bg-[hsl(343,80%,30%)] rounded-sm font-sans text-base px-8 py-5 h-auto shadow-xl hover:shadow-2xl transition-all duration-300">
            <a href="https://effet-conseil.com/rdv/">
              Prendre rendez-vous
              <ArrowRight className="ml-2 size-5" />
            </a>
          </Button>

          <p className="font-sans text-sm mt-6 text-[hsl(210,10%,23%)]/70">
            Contenu mis à jour le 5&nbsp;octobre 2026
          </p>
        </div>
      </div>

      {/* Bloc image – droite */}
      <div className="w-full lg:w-1/2 relative min-h-[30vh] lg:min-h-[35vh]">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1606874/img/law_library_hero.png" alt="Bibliothèque juridique – cadre légal de la formation professionnelle" className="absolute inset-0 w-full h-full object-cover object-center" />
        <div className="hidden lg:block absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-[#D4CBBA]/40 to-transparent pointer-events-none" />
      </div>
    </section>;
}